
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const ModalPopup = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M7.2,2.8V6.5H2.9V22.1H14.6a3.8,3.8,0,0,0,3.9-3.9v-.9a5.9,5.9,0,0,0,3.7-5.5v-9ZM17,18.2a2.4,2.4,0,0,1-2.4,2.4H4.4V8H7.2v9.8H17Zm3.7-6.4a4.5,4.5,0,0,1-4.5,4.5H8.7V4.3h12Z"></path>
        </g>
      </g>
    </IconBase>);
};

ModalPopup.defaultProps = {
  title: 'Modal Popup',
};

export default ModalPopup;
